<nav class="stepper" aria-label="Onboarding progress">
  <ol class="stepper-list">
    @for (step of steps; track step.id; let i = $index) {
      <li
        class="step"
        [attr.data-status]="statusFor(i)"
        [attr.aria-current]="statusFor(i) === 'current' ? 'step' : null">
        <span class="step-marker" aria-hidden="true">
          @if (statusFor(i) === 'complete') {
            <svg viewBox="0 0 16 16" class="check-icon">
              <path fill="currentColor" d="M6.173 11.59 3.04 8.457l1.414-1.414 1.72 1.72 4.97-4.97 1.414 1.414z"></path>
            </svg>
          } @else {
            <span class="step-number">{{ i + 1 }}</span>
          }
        </span>
        <span class="step-label">{{ step.label }}</span>
      </li>
    }
  </ol>
</nav>
